<template>
    <div class="OrderDetails">
        <Header></Header>
        <div style="width: 1000px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'margin-left': innerWidth > 1000 ? (innerWidth - 1000) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">
            <div class="title">我的订单</div>

            <div class="order_list_box" v-for="(order, index) in orderList" :key="index">
                <!-- 单个订单顶部展示 -->
                <div class="top">
                    <div class="fl" style="display: flex;">订单编号：{{ order.ordersNo }}</div>
                    <div class="fr" style="font-size: 14px;color: #7F7F7F;">
                        <span>{{ order.orderStateVal }}</span>
                    </div>
                </div>
                <!-- 单个订单底部展示 -->
                <div style="display: flex;">
                    <div class="fl order_list_left">
                        <div style="padding: 20px 0;height: 120px;">
                            <img :src="order.orderInfoList[0].goodsImage" class="good_img fl">

                            <div class="good_name_box fl">
                                <div class="good_name over_2">
                                    {{ order.orderInfoList[0].goodsName }}
                                </div>
                                <!-- <div class="category_name">2026CPA综合阶段 | 全程班</div> -->
                            </div>
                            <div class="order_num fl">x1</div>

                            <div class="order_price fl">￥{{ (order.payPrice / 100).toFixed(2) }}</div>
                        </div>
                    </div>

                    <div class="button_box fl">
                        <el-button type="primary" @click="showDetail(order.ordersId)" size="medium"
                            style="margin-top: 15px;">订单详情</el-button>
                    </div>

                </div>
            </div>

            <el-dialog :visible.sync="detailVisible" width="960px">

                <el-descriptions class="margin-top" title="订单信息" :column="3" :size="size">

                    <el-descriptions-item label="订单编号">{{ orderDetail.tradeNo }}</el-descriptions-item>
                    <el-descriptions-item label="订单状态">{{ orderDetail.orderStateVal }}</el-descriptions-item>
                    <el-descriptions-item label="订单金额"><span style="color: #E63C23;">{{ (orderDetail.payPrice /
                            100).toFixed(2)}}</span> </el-descriptions-item>
                </el-descriptions>

                <el-descriptions class="margin-top" title="" :column="1" :size="size">
                    <el-descriptions-item label="商品名称">{{ goodDetail.goodsName }}</el-descriptions-item>
                </el-descriptions>

                <el-descriptions v-if="address" class="margin-top" title="收货信息" :column="3" :size="size">
                    <el-descriptions-item label="省">{{ address.provinceName }}</el-descriptions-item>
                    <el-descriptions-item label="市">{{ address.cityName }}</el-descriptions-item>
                    <el-descriptions-item label="县/区">{{ address.areaName }}</el-descriptions-item>
                </el-descriptions>
                 <el-descriptions v-if="address" class="margin-top"  :column="3" :size="size">
                    <el-descriptions-item label="收件人">{{ address.receiveName }}</el-descriptions-item>
                    <el-descriptions-item label="收件人手机号">{{ address.receivePhone }}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions v-if="address" class="margin-top"  :column="1" :size="size">
                    <el-descriptions-item label="地址">{{ address.detailedAddress }}</el-descriptions-item>

                </el-descriptions>


            </el-dialog>


        </div>
        <Suspension></Suspension>
        <Footer></Footer>

    </div>



</template>


<script>
import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Suspension from "../../components/common/Suspension"

import {
    getByParam,
    //  sendPostRqeByJSON
} from '@/api/api.js';


import {
    // getLocalStorage
} from '@/utils/util.js';



export default {
    name: "OrderDetails",
    components: {
        Header,
        Footer,
        Suspension
    },
    data() {
        return {
            size: '',
            address: {},
            orderDetail: {
            },
            goodDetail: {},
            detailVisible: false,
            orderList: [],
            query: {
                page: 1,  // 第几页
                size: 10,  // 每页多少条
                total: 0,
            },
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },

    mounted() {
        this.getOrderPage()
    },
    methods: {
        showDetail(ordersId) {

            let param = {
                ordersId: ordersId
            }
            getByParam('/web/orders/detail', param).then(res => {
                console.log('res', res)
                this.detailVisible = true
                this.orderDetail = res.data
                this.goodDetail = this.orderDetail.orderInfos[0]
                if (res.data.addressVO) {
                    this.address = res.data.addressVO
                }else{
                    this.address = {}
                }
            })
        },
        getOrderPage() {
            let param = {
                pageNum: this.query.page,
                pageSize: this.query.size
            }
            getByParam('/web/orders/page', param).then(res => {
                console.log(res)
                this.orderList = res.data.records
                this.query.total = res.data.total

            })
        },
    },
}
</script>
<style scoped>
.title {
    font-size: 25px;
    line-height: 40px;
    font-weight: 500;
    margin-top: 50px;
}


.order_list_box {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #EDEDED;
    color: #333;
    margin-top: 20px;
}

.top {
    height: 45px;
    font-size: 12px;
    line-height: 45px;
    padding: 0 20px;
    border-bottom: 1px solid #EDEDED;
}

.order_list_left {
    padding-left: 20px;
    font-size: 16px;
    line-height: 1;
}

.good_img {
    width: 110px;
    height: 110px;
    border-radius: 10px;
    margin-right: 20px;
    /* background: url(../../../common/img/imgBg.png) no-repeat; */
    background-size: 100%;
    display: block;
}


.good_name_box {
    width: 350px;
    font-weight: 600;
}

.good_name {
    width: 340px;
}

.category_name {
    font-size: 12px;
    color: #7F7F7F;
    line-height: 15px;
    padding: 4px 8px;
    background: #F7F7F7;
    border-radius: 4px;
    border: 1px solid #E6E6E6;
    font-weight: 400;
    margin-top: 10px;
    display: inline-block;
}

.order_num {
    width: 114px;
    text-align: center;
}

.order_price {
    font-weight: 600;
    width: 142px;
    text-align: center;
    color: #E63C23;
}

.button_box {
    border-left: 1px solid #EDEDED;
    width: 190px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    cursor: pointer;
    flex: 1;
}
.margin-top{
    margin-top: 10px;

}
</style>